<template>
    <div class="accordion">
		<div class="accordion__item" :class="{'is-open': index === active}">
			<ul class="accordion__list-button">
				<li class="accordion__inner-button" ref="iconAccordion">
					<a class="accordion__button" @click="openAccordion(index)">
						<div class="accordion__button-name" :style="{background: data.buttonNameColor}">
							{{ data.buttonName }}
						</div>
						<span class="accordion__button-num">
							{{ data.userNum }}
						</span>
						<span class="accordion__button-icon">
							<SvgIcon class="accordion__button-arrow" iconName="ico-arrow-down"/>
						</span>
					</a>
				</li>
			</ul>
			<slide-up-down :active="toggleAccordion(index)" :duration="800">
				<div class="accordion__content">
					<BlockTable
						:index="index"
						:flagHide="flagHide"
						:data="data.DataAccordionTable"
						:flagCheckbox="flagCheckbox"
						@getPage="getPage"
						@updateStage="updateStage"
						@dismissStage="dismissStage"
						@showPopupNote="showPopupNote"
						:sort="data.sort"
						:sort-desc="data.sortDesc"
						@onSort="onSort"
						:total="data.total"
					/>
				</div>
			</slide-up-down>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockTable from '@/components/blocks/BlockTable';
import SlideUpDown from 'vue-slide-up-down';

export default {
	components: {
		SvgIcon,
		BlockTable,
		SlideUpDown
	},
	props: {
		data: {
			type: Object,
			required: true
		},
		index: {
			type: String,
			required: false
		},
		flagCheckbox: {
			required: false
		},
		flagHide: {
			required: false
		},
		infinitScrollFlag: {
			required: false
		}
	},
	data () {
		return {
			active: 'st_Lead'
		};
	},
	computed: {
		stagesPagination() {
			return this.$store.getters.getStagesPagination;
		},
		stagesPaginationProperty() {
			return this.$store.getters.getStagesPaginationProperty;
		},
		leadsPagination() {
			return this.$store.getters.getLeadsPagination;
		},
		stagesPaginationNotLead() {
			return this.$store.getters.getStagesPagination;
		}
	},
	methods: {
		showPopupNote(pivot) {
			this.$emit('showPopupNote', pivot);
		},
		dismissStage(obj) {
			this.$emit('dismissStage', obj);
		},
		updateStage(obj) {
			this.$emit('noLeadUpdate', obj);
		},
		openAccordion(index) {
			if (this.active === index) {
				this.active = null;
			} else {
				this.active = index;
				if (this.data.DataAccordionTable.items.length === 0) {
					this.$emit('setAgainTable', { 
						stageId: this.data.stageId, 
						page: 1,
						sortBy: this.data.sort,
						order: 'asc'
					});
				}
			}
		},
		onSort(sortBy, order) {
			if (sortBy === 'stage' || sortBy === 'stage_icon' || sortBy === 'property_shark_link' || !sortBy) return;
			this.$emit('onSort', {
				stageId: this.data.stageId,
				page: 1,
				sortBy: sortBy.replace('_label', '').replace('_customer', ''),
				order
			});
		},
		toggleAccordion(index) {
			return index === this.active;
		},
		async getPage() {
			const revertName = `st_${this.data.buttonName.replaceAll(' ', '_')}`;
			if (revertName === 'st_Lead') {
				const adminOrAgent = this.leadsPagination;
				let nextPage = adminOrAgent.current_page++;
				(adminOrAgent.current_page === 0)
					? nextPage = 1
					: nextPage = adminOrAgent.current_page++;
				if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page) {
					return false;
				}
				await this.$emit('setAgainTableLead', {
					stageId: this.data.stageId,
					page: nextPage,
					sortBy: adminOrAgent.sort_by,
					order: adminOrAgent.order
				});
			} else {
				let adminOrAgent;
				
				if (this.stagesPaginationNotLead[this.data.buttonName]) {
					adminOrAgent = this.stagesPaginationNotLead[this.data.buttonName];
				} else {
					if (this.stagesPaginationNotLead[revertName]) {
						adminOrAgent = this.stagesPaginationNotLead[revertName];
					} else {
						if (this.stagesPaginationProperty[this.data.buttonName]) {
							adminOrAgent = this.stagesPaginationProperty[this.data.buttonName];
						} else {
							adminOrAgent = this.stagesPaginationProperty[revertName];
						}
					}
				}
				
				let nextPage = adminOrAgent.current_page++;
				(adminOrAgent.current_page === 0)
					? nextPage = 1
					: nextPage = adminOrAgent.current_page++;
				if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page) {
					return false;
				}
				await this.$emit('setAgainTable', { 
					stageId: this.data.stageId,
					page: nextPage,
					sortBy: adminOrAgent.sort_by,
					order: adminOrAgent.order
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.accordion__button {
	display: flex;
	background-color: $white-lilac;
	padding: 11px 43px 11px 13px;
	margin-top: 25px;
	position: relative;
	align-items: center;
	text-decoration: none;
	transition: $dur $ease;
	border-radius: 14px;
    border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;

	@include mq($lg) {
		flex-wrap: wrap;
	}

	@include mq(350px) {
		padding: 11px 43px 11px 7px;
		margin-top: 20px;
	}

	@include hover  {
		.accordion__button-num {
			color: $dodger-blue;
			opacity: 1;
		}

		.accordion__button-arrow {
			fill: $dodger-blue;
			color: $dodger-blue;
		}
	}
}

.accordion__item {
	&.is-open {
		.accordion__button-arrow {
			transform: rotateX(-180deg);
		}

		.accordion__button-num {
			color: $dodger-blue;
			opacity: 1;
		}

		.accordion__button-arrow {
			fill: $dodger-blue;
			color: $dodger-blue;
		}
	}
}
.accordion__button-name {
	padding: 2px 7px;
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: $white;
	border-radius: 8px;
	margin-right: 13px;

	@include mq($lg) {
		font-size: 14px;
	}

	@include mq(350px) {
		font-size: 13px;
		margin-right: 5px;
	}
}

.accordion__button-num {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $shuttle-gray;
	opacity: 0.5;
	transition: $dur $ease;

	@include mq($lg) {
		font-size: 12px;
	}

	@include mq(350px) {
		font-size: 11px;
	}
}

.accordion__button-icon {
	position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
}

.accordion__button-arrow {
	font-size: 27px;
    display: block;
	transition: $dur $ease;
	color: $fiord;
}

.accordion__list-button {
	margin-bottom: 0;
	cursor: pointer;
}
</style>
